import { createSlice } from "@reduxjs/toolkit";
import { getNotifications } from "./_notificationAction";


interface ManagePricingState {
  notificationList: any[];
  loading: boolean;
  error: string | null;
  totalCount: number;
  unreadCount: number;
}

const initialState: ManagePricingState = {
  notificationList: [],
  loading: false,
  error: null,
  totalCount: 0,
  unreadCount: 0,
};


export const notificationReducer = createSlice({
  name: "notification",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setNewNotificationCount: (state) => {
      state.unreadCount += 1;
    },
    resetUnreadCount: (state) => {
      state.unreadCount = 0;
    },
    prependNotification: (state, action) => {
      state.notificationList.unshift(action.payload); // ← adds to the beginning
      state.totalCount += 1;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch notification List
      .addCase(getNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notificationList = action.payload?.data;
        state.totalCount = action.payload?.count;
      })
      .addCase(getNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

  },
});


export const { clearError, setNewNotificationCount, resetUnreadCount, prependNotification } = notificationReducer.actions;
export default notificationReducer;
